/*
 * File: /src/store/modules/campaigns.js
 * Created Date: Sunday March 17th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 2nd April 2019 11:14:02 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import { authedAxios } from 'src/shared/axiosWrapper';
import campaignService from 'src/services/campaignServices';

// initial state
const state = {
  campaigns: [],
  campaignReports: [],
  workflows: [],
  currentCampaign: {},
};

// getters return values
const getters = {
  getCampaigns: (state) => {
    return state.campaigns;
  },
  getCampaignById: (state) => (id) => {
    return state.campaigns.find((campaign) => {
      if (parseInt(campaign.id, 10) === parseInt(id, 10)) {
        return campaign;
      }
    });
  },
  getCampaignNameById: (state) => (id) => {
    const camp = state.campaigns.find((campaign) => {
      if (campaign.id === id) {
        return campaign;
      }
    });
    return camp.name;
  },
  getCampaignReport: (state) => (id) => {
    const report = state.campaignReports.find((reports) => {
      if (reports !== null && reports.id === id) {
        return reports;
      }
    });
    return report;
  },
  getCurrentCampaign: (state) => state.currentCampaign,
};

// actions return promises
const actions = {
  fetchCampaigns({ commit }) {
    if (state.campaigns.length === 0) {
      return campaignService.fetchCampaigns().then((response) => {
        // cast as an array.
        let camp = [];
        for (const id in response.data) {
          camp.push(response.data[id]);
        }
        commit('setCampaigns', camp);
      });
    }
  },
  unloadCampaigns({ commit }) {
    commit('setCampaigns', []);
  },
  fetchCampaignReports({ commit }, id) {
    return new Promise((resolve, reject) => {
      campaignService
        .fetchCampaignsReports(id)
        .then((r) => {
          const obj = {
            // id: id,
            ...r.data,
          };
          commit('addCampaignReport', obj);
          resolve(obj);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  // fetchCampaignReportHeatmap({ commit }, meta) {
  //   return new Promise((resolve, reject) => {
  //     campaignService
  //       .fetchCampaignsHeatmaps(meta.id, meta.eventType)
  //       .then((r) => {
  //         const obj = {
  //           id: meta.id,
  //           data: Object.assign([], r.data),
  //         };
  //         resolve(obj);
  //       });
  //   });
  // },
  // fetchCampaignReportErrors({ commit }, campaignId) {
  //   return new Promise((resolve, reject) => {
  //     campaignService.fetchCampaignErrors(campaignId).then((r) => {
  //       resolve(r.data);
  //     });
  //   });
  // },
  loadById({ commit, getters }, id) {
    const campaign = getters.getCampaignById(id);
    if (campaign) {
      return Promise.resolve(campaign);
    }
    return authedAxios.get('/v1/campaigns/email-report/' + id).then((response) => {
      commit('addCampaign', response.data);
      return getters.getCampaignById(id);
    });
  },
  saveNewCampaign({ commit }, campaign) {
    return new Promise((resolve, reject) => {
      // Should all be service calls
      authedAxios
        .post('/v1/campaigns/', campaign)
        .then((response) => {
          commit('addCampaign', response.data);
          resolve({ success: 1, data: response.data });
        })
        .catch((e) => {
          reject({ success: 0, error: e });
        });
    });
  },
  save({ commit, dispatch }, campaign) {
    // TODO: we need some form of object validation here.
    if (campaign.id) {
      return authedAxios
        .put('/v1/campaigns/' + campaign.id, campaign)
        .then((response) => {
          commit('updateCampaign', response.data);
          // this._vm.$emit('contact-saved');
          return campaign;
        });
    } else {
      dispatch('saveNewCampaign', campaign);
    }
  },
  saveCurrentCampaign({ commit }, meta) {
    return new Promise((resolve, reject) => {
      commit('setCurrentCampaign', meta);
      resolve({ success: 1 });
    });
  },
};

// mutations
const mutations = {
  setCampaigns(state, campaignData) {
    state.campaigns = Object.assign([], campaignData);
  },
  updateCampaign(state, campaignData) {
    const index = state.campaigns.findIndex(
      (campaign) => campaignData.id === campaign.id
    );
    if (index === -1) {
      throw new Error('Tried to update non existent record');
    }
    // We must use Vue.set to maintain reactivity.
    Vue.set(state.campaigns, index, campaignData);
  },
  addCampaignReport(state, reportData) {
    const meta = state.campaignReports;
    meta[reportData.id] = reportData;
    state.campaignReports = Object.assign([], meta);
  },
  addCampaign(state, campaignData) {
    state.campaigns.push(campaignData);
  },
  setCurrentCampaign(state, campaign) {
    state.currentCampaign = Object.assign({}, campaign);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
